import { CardConfig } from '../components/SettingsMenu';
import { PreselectionType, VariableType } from './dashboard.types';
import type { MarketZoneId } from '@app/common/static-data/energy-markets';
import { MarketAggregatesState } from '../contexts/types';

export interface DashboardTab {
  id: string;
  name: string;
  isActive: boolean;
  createdAt: number;
  lastModified: number;
}

export interface TabState {
  // Card and layout configurations
  cardConfigs: CardConfig[];
  layouts: any; // react-grid-layout layouts object

  // Global selection states
  selectedPreselection: PreselectionType;
  selectedVariable: VariableType;
  selectedZone: MarketZoneId | null;
  selectedZones?: MarketZoneId[];

  // Context state (will be serialized/deserialized as needed)
  contextState?: Partial<MarketAggregatesState>;
}

export interface TabManagerState {
  tabs: DashboardTab[];
  activeTabId: string;
  tabStates: Record<string, TabState>;
}

export interface CreateTabOptions {
  name?: string;
  copyFromActiveTab?: boolean;
  templateType?: 'default' | 'minimal' | 'analytics';
}

export const TAB_TEMPLATES = {
  default: {
    name: 'Default Dashboard',
    description: 'Standard layout with all cards enabled',
  },
} as const;

export type TabTemplate = keyof typeof TAB_TEMPLATES;
